import React from "react";
import { Box, Button } from "@mui/material";
import MaterialModal from "../../../app/material-modal";
import CohortPeriodsTable from "./CohortPeriodsTable";

export function CohortPeriodsModal({cohortPeriodData}) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Box sx={{ width: "100%" }}>
      <Button variant="contained" fullWidth onClick={handleOpen}>
        Edit Cohort Periods
      </Button>
      <MaterialModal
        open={open}
        handleDialogClose={handleClose}
        styleOverrides={{
          container: {
            "& .MuiDialog-paper": {
              width: "100%",
              minHeight: "400px",
              minWidth: "700px",
              ".MuiDialogContent-root": {
                overflow: "auto",
              },
            },
          },
        }}
        title="Cohort Period Settings"
      >
        <CohortPeriodsTable cohortPeriodData={cohortPeriodData} handleClose={handleClose}/>
      </MaterialModal>
    </Box>
  );
}
